import { render } from "./simpleConfirmComponent.vue?vue&type=template&id=b26629c2&scoped=true"
import script from "./simpleConfirmComponent.vue?vue&type=script&lang=js"
export * from "./simpleConfirmComponent.vue?vue&type=script&lang=js"

import "./simpleConfirmComponent.vue?vue&type=style&index=0&id=b26629c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26629c2"]])

export default __exports__